import request from '@/utils/request'

const baseUrl = '/erp/finance/report/expense-summary'

export const pageExpenseSummaryReport = params => request({
  url: baseUrl + '/page',
  method: 'get',
  params
})

export const exportExpenseSummaryReport = params => request({
  url: baseUrl + '/export',
  method: 'get',
  params,
  responseType: 'blob'
})
